import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Chip, Box, useMediaQuery, useTheme } from "@mui/material";
import "../../Styles/style.css";
import AdminApiModule from "../../components/AdminApi/Api/api";
import ViewActions from "../../components/AdminApi/ViewActions";
import ViewVerify from "../../components/AdminApi/ViewVerify";
import Button from "@mui/material/Button";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import StarIcon from "@mui/icons-material/Star";
import DownloadIcon from "@mui/icons-material/Download";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_URL } from "../../components/config/config";
import DeleteAlertDialogModal from "../../components/Components/DeleteAlert";
import moment from "moment";
import SimpleCapacityPopup from "./Pop-up/Center/SimpleCapacityPopup";
import DefineCapacityPopup from "./Pop-up/Center/DefineCapacityPopup";
import {
  canViewCenter,
  canViewCenterDetails,
  canAddCenter,
  canUpdateCenter,
  canDeleteCenter,
  canViewPincode,
  canViewNumber,
  canDefineCapacity,
  canAuthorizeClient,
  canViewCenterHistory,
  canViewDocuments,
  canDownloadCenterList,
} from "../../utility/permissionUtils";
import CentersFilter from "./Filters/CentersFilter";

const activeStatus = {
  2: "DRAFTED",
  "-1": "IN_ACTIVE",
  1: "ACTIVE",
  0: "DELETED",
};

const Centers = () => {
  const reduxState = useSelector((state) => state.userReducer);
  const globalState = useSelector((state) => state.AdminReducer);
  const userPermissions = globalState?.adminDetails?.role_id?.permissions;
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const ticketTableRef = useRef(null);
  const [autoTriggerFilter, setAutoTriggerFilter] = useState(true);
  const [dateFilter, setDateFilter] = useState(null);
  const [isCapacityPopupOpen, setIsCapacityPopupOpen] = useState(false);
  const [isCapacityPopupOpen1, setIsCapacityPopupOpen1] = useState(false);
  const [selectedCenterForCapacity, setSelectedCenterForCapacity] =
    useState(null);
  const [activeFilters, setActiveFilters] = useState({});
  const [primaryServicesList, setPrimaryServicesList] = useState([]);
  const [secondaryServicesList, setSecondaryServicesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [initialFiltersLoaded, setInitialFiltersLoaded] = useState(false);

  const [state, setState] = useState({
    centersList: [],
    snackbar: {
      open: false,
      message: "",
      severity: "success",
    },
    error: "",
    success: "",
    isCapacityPopupOpen: false,
    capacityForm: {
      ticket_accept_limit: "",
      qr_id: "",
    },
    isAuthorizedForPopupOpen: false,
    isVerificationPopupOpen: false,
    isDeleteAlertPopupOpen: false,
    selectedCenterId: "",
    centerDeleteId: "",
    deleteHeading: "Center",
    selectedCenterData: {},
    isLoading: false,
    adminId: reduxState?.adminDetails?._id,
    ticketData: [],
    isSwitchOn: false,
    isSwitchPan: null,
    isSwitchOnAdharFront: null,
    isSwitchOnAdharBack: null,
    panStatus: null,
    profilePicture: null,
    panVerified: false,
    aadhar_font: false,
    aadhar_back: false,
    toast: {
      open: false,
      msg: "",
      duration: 5000,
      type: "",
    },
    clientsList: [],
    isCapacityPopupOpen1: false,
  });

  useEffect(() => {
    if (state.centersList && state.centersList.length > 0) {
      const primaryServices = [
        ...new Set(
          state.centersList
            .map((center) => center.primary_services)
            .filter((service) => service && service.trim() !== "")
        ),
      ].sort();

      const secondaryServices = [
        ...new Set(
          state.centersList
            .map((center) => center.secondary_services?.split(", "))
            .flat()
            .filter((service) => service && service.trim() !== "")
        ),
      ].sort();

      // Extract unique states from the data
      const uniqueStates = [
        ...new Set(
          state.centersList
            .map((center) => {
              // Get the status from the action object (original data)
              const status = center.action?.is_active;
              if (status !== undefined && status !== null) {
                return status.toString();
              }
              // Fallback: try to get from status field if available
              const statusLabel = center.status;
              if (statusLabel) {
                // Reverse lookup from activeStatus
                const statusValue = Object.keys(activeStatus).find(
                  (key) => activeStatus[key] === statusLabel
                );
                return statusValue || null;
              }
              return null;
            })
            .filter((status) => status !== null)
        ),
      ].sort();

      // Map states to their labels
      const statesWithLabels = uniqueStates.map((stateValue) => ({
        value: stateValue,
        label: activeStatus[stateValue] || stateValue,
      }));

      setPrimaryServicesList(primaryServices);
      setSecondaryServicesList(secondaryServices);
      setStatesList(statesWithLabels);
    }
  }, [state.centersList]);

  // Load saved column widths from localStorage
  const loadColumnWidths = () => {
    try {
      const saved = localStorage.getItem("centersColumnWidths");
      return saved ? JSON.parse(saved) : {};
    } catch (error) {
      console.error("Error loading column widths:", error);
      return {};
    }
  };

  const savedColumnWidths = loadColumnWidths();

  // Helper function to get column width with fallback
  const getColumnWidth = (field, defaultWidth) => {
    return savedColumnWidths[field] || defaultWidth;
  };

  const columns = [
    {
      field: "center_name",
      headerName: "Name",
      width: savedColumnWidths.center_name || 150,
      filterable: false,
      sortable: false,
    },
    {
      field: "last_active",
      headerName: "Last Active",
      width: savedColumnWidths.last_active || 130,
      filterable: false,
      sortable: true,
      renderCell: (params) => {
        return params.value ? params.value : "-";
      },
    },
    {
      field: "wallet_balance",
      headerName: "Wallet Balance",
      width: getColumnWidth("wallet_balance", 150),
      type: "number",
      filterable: false,
      sortable: true,
      renderCell: (params) => {
        const balance = params.value ?? 0;
        return `₹${balance.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      field: "closedTickets",
      headerName: "Total Request closed",
      width: getColumnWidth("closedTickets", 180),
      type: "number",
      filterable: true,
      sortable: true,
    },
    {
      field: "ticket_accept_limit",
      headerName: "Center Pending Limit",
      width: getColumnWidth("ticket_accept_limit", 180),
      filterable: false,
      sortable: false,
    },
    {
      field: "Subscribed",
      headerName: "Subscribed",
      width: getColumnWidth("Subscribed", 150),
      filterable: true,
      sortable: false,
      renderCell: (params) => {
        return params.value == "Not Subscribed" ? (
          <Chip label="Not Subscribed" style={{ backgroundColor: "red" }} />
        ) : (
          <Chip label="Subscribed" style={{ backgroundColor: "#8FD1AD" }} />
        );
      },
    },
    {
      field: "phone",
      headerName: "Phone",
      width: getColumnWidth("phone", 130),
      filterable: false,
      sortable: false,
      hide:
        !canViewNumber &&
        reduxState?.adminDetails?.role_id?.role !== "SUPER_ADMIN",
    },
    {
      field: "qrCode",
      headerName: "QR Code",
      width: getColumnWidth("qrCode", 130),
      filterable: false,
      sortable: false,
    },
    {
      field: "service_picode",
      headerName: "Service Pincode",
      width: getColumnWidth("service_picode", 160),
      filterable: false,
      sortable: false,
      hide: !canViewPincode,
    },
    {
      field: "pincode",
      headerName: "Address Pincode",
      width: getColumnWidth("pincode", 160),
      filterable: false,
      sortable: false,
      hide: !canViewPincode,
    },
    {
      field: "primary_services",
      headerName: "Primary Skill",
      width: getColumnWidth("primary_services", 150),
      filterable: true,
      sortable: false,
    },
    {
      field: "secondary_services",
      headerName: "Secondary Skill",
      width: getColumnWidth("secondary_services", 180),
      filterable: true,
      sortable: false,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: getColumnWidth("createdAt", 130),
      filterable: false,
      sortable: false,
    },
    {
      field: "onboarded_by",
      headerName: "Onboarded By",
      width: getColumnWidth("onboarded_by", 150),
      filterable: false,
      sortable: false,
    },
    {
      field: "authorizedFor",
      headerName: "Authorized For Clients",
      width: getColumnWidth("authorizedFor", 200),
      filterable: true,
      sortable: false,
      hide: !canAuthorizeClient,
    },
    {
      field: "is_otp_verfied",
      headerName: "OTP Verification",
      width: getColumnWidth("is_otp_verfied", 160),
      filterable: true,
      sortable: false,
      renderCell: (params) => {
        return params.value == true ? (
          <Chip label="Verified" style={{ backgroundColor: "#8FD1AD" }} />
        ) : (
          <Chip
            label="Not Verified"
            style={{ backgroundColor: "red", color: "white" }}
          />
        );
      },
    },
    {
      field: "Average_Rating",
      headerName: "Average_Rating",
      width: getColumnWidth("Average_Rating", 160),
      filterable: true,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.value} <StarIcon style={{ color: "yellow" }} />
          </div>
        );
      },
    },
    ...(canViewDocuments
      ? [
          {
            field: "verificationDetails",
            headerName: "View Verification Details",
            width: getColumnWidth("verificationDetails", 200),
            filterable: false,
            sortable: true,
            renderCell: (params) => {
              const centerData = params.row?.action;
              const hasImage =
                centerData &&
                centerData.document_details &&
                centerData.document_details.aadhar_card_document &&
                centerData.document_details.aadhar_card_document.front_side &&
                centerData.document_details.aadhar_card_document.front_side.endsWith(
                  ".jpg"
                );

              return hasImage ? (
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#303F9F" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleVerificationDetailsPopup(centerData, true);
                  }}
                >
                  <RemoveRedEyeIcon />
                  {!isMobile && "View"}
                </Button>
              ) : (
                <span>No documents</span>
              );
            },
          },
        ]
      : []),
    {
      field: "action",
      headerName: "Action",
      width: getColumnWidth("action", isMobile ? 200 : 700),
      filterable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const centerData = params.row?.action;
        const value = params.row?.action;

        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: isMobile ? "wrap" : "nowrap",
              gap: 1,
              width: "100%",
            }}
          >
            {canViewCenterDetails && (
              <Button
                sx={{
                  fontSize: "12px",
                  minWidth: isMobile ? "80px" : "auto",
                }}
                variant="contained"
                size={isMobile ? "small" : "medium"}
                onClick={() => handleViewCenter(value._id)}
              >
                {isMobile ? "View" : "View Center"}
              </Button>
            )}

            {canDefineCapacity && (
              <Button
                className="text-transform-none"
                variant="contained"
                size={isMobile ? "small" : "medium"}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedCenterForCapacity(params.row);
                  setIsCapacityPopupOpen1(true);
                }}
              >
                {isMobile ? "Capacity" : "Define Capacity"}
              </Button>
            )}

            {canAuthorizeClient && (
              <Button
                className="text-transform-none"
                variant="contained"
                size={isMobile ? "small" : "medium"}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleAuthorizedForPopup(value._id);
                }}
              >
                {isMobile ? "Auth" : "Authorized For"}
              </Button>
            )}

            {canUpdateCenter && (
              <Button
                className="text-transform-none"
                variant="contained"
                size={isMobile ? "small" : "medium"}
                onClick={() => redirectToEditCenter(value._id)}
              >
                {isMobile ? "Edit" : "Edit"}
              </Button>
            )}

            {canDeleteCenter && (
              <Button
                variant="contained"
                size={isMobile ? "small" : "medium"}
                onClick={(e) => {
                  e.stopPropagation();
                  clickDeleteCenter(value._id);
                }}
                sx={{ backgroundColor: "#FCE9F1", minWidth: "auto" }}
              >
                <DeleteIcon
                  sx={{ color: "red", fontSize: isMobile ? "18px" : "24px" }}
                />
              </Button>
            )}

            {canViewCenterHistory && (
              <Button
                className="text-transform-none"
                variant="contained"
                size={isMobile ? "small" : "medium"}
                onClick={() => centerHistory(value._id)}
              >
                {isMobile ? "History" : "History"}
              </Button>
            )}

            {canUpdateCenter &&
              moment().diff(moment(value?.extended_date), "days") > 15 && (
                <Button
                  className="text-transform-none"
                  variant="contained"
                  size={isMobile ? "small" : "medium"}
                  onClick={() => extendTrial(value._id)}
                >
                  {isMobile ? "Extend" : "Extend Trial"}
                </Button>
              )}
          </Box>
        );
      },
    },
  ];

  const extendTrial = async (centerId) => {
    if (!canUpdateCenter) {
      showDialog(true, "error", "You don't have permission to extend trial");
      return;
    }

    let accessToken = localStorage.getItem("access_token");
    const payload = {
      center_obj_id: centerId,
      extended_date: moment().format(),
    };
    try {
      await axios.post(
        `${BASE_URL}admin/update-center-extended-date`,
        payload,
        {
          headers: {
            "x-access-token": accessToken,
          },
        }
      );
      setState({
        ...state,
        success: "Trial extended successfully",
        error: "",
        snackbar: {
          open: true,
          message: "Trial extended successfully",
          severity: "success",
        },
      });
    } catch (error) {
      console.error("Error extending trial", error);
      setState({
        ...state,
        error: "Error extending trial",
        success: "",
        snackbar: {
          open: true,
          message: "Error extending trial",
          severity: "error",
        },
      });
    }
  };

  const centerHistory = (centerId) => {
    if (!canViewCenterHistory) {
      showDialog(
        true,
        "error",
        "You don't have permission to view center history"
      );
      return;
    }
    navigate(`/center-history/${centerId}`);
  };

  const redirectToEditCenter = (id) => {
    if (!canUpdateCenter) {
      showDialog(true, "error", "You don't have permission to edit centers");
      return;
    }
    navigate("/add-center?edit=" + id);
  };

  const clickDeleteCenter = (centerId) => {
    if (!canDeleteCenter) {
      showDialog(true, "error", "You don't have permission to delete centers");
      return;
    }
    setState({
      ...state,
      centerDeleteId: centerId,
      isDeleteAlertPopupOpen: true,
    });
    localStorage.setItem("centerId", centerId);
  };

  const handleDeleteCloseModal = () => {
    setState({ ...state, isDeleteAlertPopupOpen: false });
  };

  const deleteCenter = async () => {
    let accessToken = localStorage.getItem("access_token");
    let centerId = localStorage.getItem("centerId");

    try {
      await axios.delete(`${BASE_URL}admin/deleteCenter/${centerId}`, {
        headers: {
          "x-access-token": accessToken,
        },
      });
      handleDeleteCloseModal();
      getAllCenters();
    } catch (error) {
      console.log(error);
    }
  };

  const refreshData = () => {
    setActiveFilters({});
    localStorage.removeItem("centersFilters");
    getAllCentersWithFilters();
  };

  const showDialog = (open, type, msg) => {
    setState({
      ...state,
      toast: {
        open: open,
        msg: msg,
        duration: 5000,
        type: type,
      },
    });
  };

  const closeDialog = (open = false) => {
    setState({
      ...state,
      toast: {
        open: open,
        msg: "",
        duration: 5000,
        type: "",
      },
    });
  };

  const startLoading = () => {
    setState({ ...state, isLoading: true });
  };

  const stopLoading = () => {
    setState({ ...state, isLoading: false });
  };

  const getAllClients = useCallback(() => {
    new AdminApiModule()
      .getAllClients()
      .then((res) => {
        let parsedData = [];
        if (res && res.data && res.data.length > 0) {
          parsedData = res.data;
        }
        setState((prevState) => ({ ...prevState, clientsList: parsedData }));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getFormattedServices = (services) => {
    let secondary_services_list = [];
    services &&
      services.length > 0 &&
      services.forEach((item) => {
        const serviceName = item?.secondary_services_id?.service_name;
        if (serviceName) {
          const parts = serviceName.split("-");
          const serviceNameFirstPart = parts[0]?.trim();
          if (serviceNameFirstPart) {
            secondary_services_list.push(serviceNameFirstPart);
          }
        }
      });
    return secondary_services_list.join(", ");
  };

  const getFormattedClients = (clients) => {
    let clients_list = [];
    clients &&
      clients.length > 0 &&
      clients.map((item) => {
        clients_list.push(item.client_name);
      });
    return clients_list.length > 0 ? clients_list.join(", ") : "";
  };

  const getParsedData = (data) => {
    if (!data || !Array.isArray(data)) {
      return [];
    }

    let dateFormat = { year: "numeric", month: "short", day: "numeric" };
    let parsedData = data.map((item, index) => {
      const isSuperAdmin =
        reduxState?.adminDetails?.admin_role === "SUPER_ADMIN";
      const canViewPhone = canViewNumber || isSuperAdmin;

      return {
        id: item?._id || index,
        center_name: item?.center_name || "-",
        last_active: item?.updatedAt
          ? new Date(item?.updatedAt)?.toLocaleDateString("en-GB")
          : "-",
        wallet_balance: item?.technician_wallet?.balance ?? 0,
        Subscribed:
          item?.payment_details?.paid_for_onboarding_kit === false
            ? "Not Subscribed"
            : "Subscribed",
        phone: canViewPhone
          ? item?.personal_details?.phone?.mobile_number || "-"
          : "*****",
        qrCode: item?.qr_details?.qr_id || "-",
        qrStatus: item?.qr_details?.qrStatus == true ? "True" : "False",
        subscription_end_date: item?.payment_details?.subscribe_end_date
          ? item.payment_details?.subscribe_end_date
          : "Not subscribed",
        service_picode: canViewPincode
          ? (item?.services?.pincodes || []).join(", ")
          : "*****",
        pincode: canViewPincode ? item?.address_details?.pincode : "*****",
        additional_pincode: canViewPincode
          ? item?.address_details?.additional_pincode
          : "*****",
        primary_services: `${
          item?.services?.primary_services &&
          item?.services?.primary_services.length > 0
            ? item?.services?.primary_services[0]?.service_name
                ?.split("-")[0]
                ?.trim() || ""
            : ""
        }`,
        secondary_services: `${getFormattedServices(
          item?.services?.secondary_services
        )}`,
        status: activeStatus[item.is_active] || "-",
        createdAt: item?.createdAt
          ? new Date(item?.createdAt)?.toLocaleDateString("en-US", dateFormat)
          : "-",
        onboarded_by: item?.referral_received ? item?.referral_received : "-",
        authorizedFor: canAuthorizeClient
          ? getFormattedClients(item?.clients_ids_list)
          : "*****",
        verify: {
          checked: item?.verification_status === "true",
          value: item?.verification_status || "",
        },
        action: item,
        closedTickets:
          parseFloat(item?.count_details?.closed_ticket_count) || 0,
        Average_Rating: item?.count_details?.average_ticket_rating || 0,
        verify:
          item?.document_details?.aadhar_card_document?.aadhar_back_verified,
        center_obj_id: item?._id,
        is_otp_verfied: item?.otp_details?.is_otp_verfied || false,
        ticket_accept_limit: item?.ticket_accept_limit || 0,
      };
    });

    return parsedData;
  };

  const getAllCentersWithFilters = useCallback(
    async (filters = {}) => {
      if (!canViewCenter) {
        showDialog(true, "error", "You don't have permission to view centers");
        return;
      }

      startLoading();

      try {
        let payload = { ...filters };

        if (Object.keys(payload).length > 0) {
          localStorage.setItem("centersFilters", JSON.stringify(payload));
        }

        const queryParams = new URLSearchParams();
        Object.keys(payload).forEach((key) => {
          if (
            payload[key] !== undefined &&
            payload[key] !== null &&
            payload[key] !== ""
          ) {
            // URLSearchParams automatically handles URL encoding
            queryParams.append(key, payload[key]);
          }
        });

        const queryString = queryParams.toString();
        const url = queryString
          ? `${BASE_URL}admin/get-all-centers?${queryString}`
          : `${BASE_URL}admin/get-all-centers`;

        const accessToken = localStorage.getItem("access_token");

        const response = await axios.get(url, {
          headers: {
            "x-access-token": accessToken,
          },
        });

        const parsedData = getParsedData(
          response?.data?.data || response?.data || []
        );
        setState((prevState) => ({
          ...prevState,
          centersList: parsedData || [],
          isLoading: false,
        }));
      } catch (error) {
        console.error("Error fetching centers:", error);
        setState((prevState) => ({
          ...prevState,
          centersList: [],
          isLoading: false,
        }));
        showDialog(true, "error", "Failed to fetch centers data");
      }
    },
    [canViewCenter]
  );

  // Handle filter submission
  const handleFilterSubmit = (filters) => {
    setActiveFilters(filters);
    localStorage.setItem("centersFilters", JSON.stringify(filters));
    getAllCentersWithFilters(filters);
  };

  // Handle clear filters
  const handleClearFilters = () => {
    setActiveFilters({});
    localStorage.removeItem("centersFilters");
    const oneWeekAgo = moment().subtract(7, "days").format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    const defaultFilters = {
      start_date: oneWeekAgo,
      end_date: today,
    };
    getAllCentersWithFilters(defaultFilters);
  };

  const getAllCenters = useCallback(() => {
    getAllCentersWithFilters(activeFilters);
  }, [getAllCentersWithFilters, activeFilters]);

  const toggleAuthorizedForPopup = (centerId) => {
    if (!canAuthorizeClient) {
      showDialog(
        true,
        "error",
        "You don't have permission to authorize clients"
      );
      return;
    }

    if (centerId) {
      setState({ ...state, selectedCenterId: centerId });
    }
    setState((prevState) => ({
      ...prevState,
      isAuthorizedForPopupOpen: !prevState.isAuthorizedForPopupOpen,
    }));
  };

  const toggleVerificationDetailsPopup = (centerData, open = true) => {
    if (!canViewDocuments) {
      showDialog(true, "error", "You don't have permission to view documents");
      return;
    }

    if (open && centerData) {
      const access_token = localStorage.getItem("access_token");
      axios
        .get(`${BASE_URL}admin/getCenterDetails/${centerData?._id}`, {
          headers: {
            Authorization: access_token,
          },
        })
        .then((res) => {
          const selectedCenterData = res?.data?.data?.CenterDetails?.cenData;
          localStorage.setItem("centerID", centerData?._id);
          const centerId = centerData?._id;
          setState((prevState) => ({
            ...prevState,
            selectedCenterData,
            selectedCenterId: centerId,
            isVerificationPopupOpen: true,
          }));
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    } else {
      setState((prevState) => ({
        ...prevState,
        isVerificationPopupOpen: false,
      }));
    }
  };

  const handleAdharFront = () => {
    const checkCurrent = state.isSwitchOnAdharFront;

    setState(
      {
        ...state,
        isSwitchOnAdharFront: !checkCurrent,
      },
      () => {
        adharFrontPayload(state.isSwitchOnAdharFront)
          .then(() => {
            console.log("API call successful");
          })
          .catch((error) => {
            console.error("API error:", error);
            setState((prevState) => ({
              ...prevState,
              isSwitchOnAdharFront: !prevState.isSwitchOnAdharFront,
            }));
          })
          .finally(() => {
            getRecentDocumentVerify();
          });
      }
    );
    setTimeout(() => {
      getRecentDocumentVerify();
    }, 3000);
  };

  const adharFrontPayload = (status, value) => {
    return new Promise((resolve, reject) => {
      const payload = {
        Admin_id: state.adminId,
        status: status.toString(),
        center_id: state.selectedCenterId,
        value: "aadhar_front",
      };

      axios
        .post(
          `${BASE_URL}admin/Set-Verification-Status-Of-center-And-Technician`,
          payload
        )
        .then((response) => {
          resolve(response.data);
          getRecentDocumentVerify();
          setState({
            ...state,
            toast: {
              open: true,
              msg: "Aadhar Card Front Document Verified Done.",
              duration: 5000,
              type: "success",
            },
          });
        })
        .catch((error) => {
          console.error("API error:", error);
          reject(error);
        });
    });
  };

  const handleAdharBack = () => {
    const checkCurrent = state.isSwitchOnAdharBack;

    setState(
      {
        ...state,
        isSwitchOnAdharBack: !checkCurrent,
      },
      () => {
        adharBackPayload(state.isSwitchOnAdharBack)
          .then(() => {
            console.log("API call successful");
          })
          .catch((error) => {
            console.error("API error:", error);
            setState((prevState) => ({
              ...prevState,
              isSwitchOnAdharBack: !prevState.isSwitchOnAdharBack,
            }));
          })
          .finally(() => {
            getRecentDocumentVerify();
          });
      }
    );
    setTimeout(() => {
      getRecentDocumentVerify();
    }, 3000);
  };

  const adharBackPayload = (status, value) => {
    return new Promise((resolve, reject) => {
      const payload = {
        Admin_id: state.adminId,
        status: status.toString(),
        center_id: state.selectedCenterId,
        value: "aadhar_back",
      };

      axios
        .post(
          `${BASE_URL}admin/Set-Verification-Status-Of-center-And-Technician`,
          payload
        )
        .then((response) => {
          resolve(response.data);
          getRecentDocumentVerify();
          setState({
            ...state,
            toast: {
              open: true,
              msg: "Aadhar Card Back Document Verified Done.",
              duration: 5000,
              type: "success",
            },
          });
        })
        .catch((error) => {
          console.error("API error:", error);
          reject(error);
        });
    });
  };

  const handleSwitchToggle = (documentType) => {
    const checkCurrent = state.isSwitchPan;

    setState(
      {
        ...state,
        isSwitchPan: !checkCurrent,
      },
      () => {
        sendPayloadToAPI(state.isSwitchPan, documentType)
          .then(() => {
            console.log("API call successful");
          })
          .catch((error) => {
            console.error("API error:", error);
            setState((prevState) => ({
              ...prevState,
              isSwitchOn: !prevState.isSwitchOn,
            }));
          })
          .finally(() => {
            getRecentDocumentVerify();
          });
      }
    );
    setTimeout(() => {
      getRecentDocumentVerify();
    }, 3000);
  };

  const sendPayloadToAPI = (status, value) => {
    return new Promise((resolve, reject) => {
      const payload = {
        Admin_id: state.adminId,
        status: status.toString(),
        center_id: state.selectedCenterId,
        value: "pan",
      };

      axios
        .post(
          `${BASE_URL}admin/Set-Verification-Status-Of-center-And-Technician`,
          payload
        )
        .then((response) => {
          resolve(response.data);
          getRecentDocumentVerify();
          setState({
            ...state,
            toast: {
              open: true,
              msg: "Pan Verified Done.",
              duration: 5000,
              type: "success",
            },
          });
        })
        .catch((error) => {
          console.error("API error:", error);
          reject(error);
        });
    });
  };

  const saveAuthorizedCenters = (centersSelected) => {
    if (!canAuthorizeClient) {
      showDialog(
        true,
        "error",
        "You don't have permission to authorize clients"
      );
      return;
    }

    let payload = {
      center_obj_id: state.selectedCenterId,
      clients_ids_list: [...centersSelected],
    };

    new AdminApiModule()
      .adminUpdateCenter(payload)
      .then((res) => {
        showDialog(true, "success", "Center updated successfully");

        setTimeout(() => {
          toggleAuthorizedForPopup();
          getAllCenters();
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        showDialog(true, "error", err?.response?.data?.message);
      });
  };

  const handleVerifyChange = (event, centerId) => {
    const centersList = [...state.centersList];
    const centerIndex = centersList.findIndex((c) => c.action._id === centerId);

    if (centerIndex > -1) {
      centersList[centerIndex].verify.checked = event.target.checked;
      centersList[centerIndex].verify.value = event.target.checked
        ? "true"
        : "false";
      setState({ ...state, centersList });
    }

    const status = event.target.checked ? "true" : "false";
    const payload = {
      Admin_id: state.adminId,
      status: status,
      center_id: centerId,
    };
    new AdminApiModule()
      .updateCenterVerifyStatus(payload)
      .then((res) => {
        setState({
          ...state,
          toast: {
            open: true,
            msg: "Center verification status updated successfully.",
            duration: 5000,
            type: "success",
          },
        });
      })
      .catch((error) => {
        setState({
          ...state,
          toast: {
            open: true,
            msg: "Failed to update center verification status.",
            duration: 5000,
            type: "error",
          },
        });
      });
  };

  const handleRowClick = (params) => {
    const center_obj_id = params.row.center_obj_id;

    axios
      .get(`${BASE_URL}center/get-all-center-ticket/${center_obj_id}`)
      .then((response) => {
        setState({ ...state, ticketData: response.data.data }, () => {
          if (ticketTableRef.current) {
            ticketTableRef.current.scrollIntoView({ behavior: "smooth" });
          }
        });
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  };

  const renderTicketTable = () => {
    const { ticketData } = state;

    if (ticketData.length === 0) {
      return null;
    }

    const ticketColumns = [
      {
        field: "createdAt",
        headerName: "Created At",
        width: 130,
        filterable: false,
        sortable: true,
      },
      {
        field: "ticket_id",
        headerName: "Request ID",
        width: 150,
        filterable: true,
        sortable: true,
      },
      {
        field: "ticket_status",
        headerName: "Request Status",
        width: 150,
        filterable: true,
        sortable: true,
      },
      {
        field: "customer_name",
        headerName: "Customer Name",
        width: 150,
      },
      {
        field: "specific_requirement",
        headerName: "Specific Req",
        width: 150,
        filterable: true,
        sortable: true,
      },
      {
        field: "closedAt",
        headerName: "Closed At",
        width: 130,
        filterable: false,
        sortable: true,
      },
      {
        field: "ticket_price",
        headerName: "Ticket Closing Price",
        width: 180,
        type: "number",
      },
      {
        field: "ticket_pick_price",
        headerName: "Ticket Pick Price",
        width: 150,
        type: "number",
      },
    ];

    const ticketRows = ticketData.map((ticket, index) => ({
      id: ticket._id || ticket.ticket_id || index,
      createdAt: new Date(ticket.createdAt).toLocaleDateString("en-US"),
      ticket_id: ticket.ticket_id,
      ticket_status: ticket.ticket_status,
      customer_name: ticket?.personal_details?.name,
      specific_requirement: ticket?.specific_requirement,
      closedAt: ticket.closedAt
        ? new Date(ticket.closedAt).toLocaleDateString("en-US")
        : "N/A",
      ticket_price: ticket.closing_ticket_price,
      ticket_pick_price: ticket.ticket_price,
    }));

    return (
      <Box ref={ticketTableRef} sx={{ marginBottom: "20px" }}>
        <Box sx={{ mb: 2, fontSize: "1.25rem", fontWeight: 500 }}>
          Request Details
        </Box>
        <Box sx={{ height: 400 }}>
          <DataGrid
            rows={ticketRows}
            columns={ticketColumns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5, 10, 25]}
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-cell": {
                fontSize: isMobile ? "0.75rem" : "0.875rem",
                textAlign: "start",
              },
              "& .MuiDataGrid-columnHeaders": {
                fontWeight: "bold",
                fontSize: isMobile ? "0.875rem" : "1rem",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
            }}
          />
        </Box>
      </Box>
    );
  };

  const handleViewCenter = (centerId) => {
    if (!canViewCenterDetails) {
      showDialog(
        true,
        "error",
        "You don't have permission to view center details"
      );
      return;
    }
    // Open in new tab
    window.open(`/#/view-center/${centerId}`, "_blank");
  };

  const handleDownloadCSV = () => {
    if (!state.centersList || state.centersList.length === 0) {
      showDialog(true, "error", "No data to download");
      return;
    }

    // Get column headers (excluding action column)
    const headers = columns
      .filter((col) => col.field !== "action")
      .map((col) => col.headerName);

    // Get data rows
    const rows = state.centersList.map((row) => {
      return columns
        .filter((col) => col.field !== "action")
        .map((col) => {
          let value = row[col.field];

          // Handle special cases for formatted values
          if (col.field === "Subscribed") {
            value =
              value === "Not Subscribed" ? "Not Subscribed" : "Subscribed";
          } else if (col.field === "is_otp_verfied") {
            value = value === true ? "Verified" : "Not Verified";
          } else if (col.field === "Average_Rating") {
            value = value || 0;
          }

          // Convert to string and handle commas/quotes
          if (value === null || value === undefined || value === "") return "";
          const stringValue = String(value);
          // Escape quotes and wrap in quotes if contains comma or quote
          if (stringValue.includes(",") || stringValue.includes('"')) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        });
    });

    // Combine headers and rows
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const today = moment().format("YYYY-MM-DD");
    const fileName = `All_Centers_${today}.csv`;
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCapacitySubmit = async (formData) => {
    if (!canDefineCapacity) {
      showDialog(true, "error", "You don't have permission to define capacity");
      return;
    }

    const { ticket_accept_limit, qr_id, duration } = formData;
    const accessToken = localStorage.getItem("access_token");

    try {
      const payload = {
        ticket_accept_limit: parseInt(ticket_accept_limit),
        center_obj_id: selectedCenterForCapacity?.center_obj_id,
      };

      if (qr_id) {
        payload.qr_id = qr_id;
      }

      if (duration) {
        payload.duration = duration;
      }

      const response = await axios.post(
        `${BASE_URL}admin/update-ticket-accept-limit`,
        payload,
        {
          headers: {
            "x-access-token": accessToken,
          },
        }
      );

      setIsCapacityPopupOpen1(false);
      setSelectedCenterForCapacity(null);
      setState({
        ...state,
        capacityForm: { ticket_accept_limit: "", qr_id: "", duration: "" },
        snackbar: {
          open: true,
          message: "Center Capacity Defined Successfully",
          severity: "success",
        },
      });

      getAllCenters();
    } catch (error) {
      console.error("Error updating center capacity:", error);
      setState({
        ...state,
        snackbar: {
          open: true,
          message:
            error.response?.data?.message || "Failed to update center capacity",
          severity: "error",
        },
      });
    }
  };

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      adminId: reduxState?.adminDetails?._id,
    }));

    const loadInitialData = async () => {
      if (initialFiltersLoaded) return;

      const savedFilters = localStorage.getItem("centersFilters");
      let filtersToApply = {};

      if (savedFilters) {
        try {
          filtersToApply = JSON.parse(savedFilters);
          setActiveFilters(filtersToApply);
        } catch (error) {
          console.error("Error loading saved filters:", error);
          localStorage.removeItem("centersFilters");
          const oneWeekAgo = moment().subtract(7, "days").format("YYYY-MM-DD");
          const today = moment().format("YYYY-MM-DD");
          filtersToApply = {
            start_date: oneWeekAgo,
            end_date: today,
          };
          setActiveFilters(filtersToApply);
        }
      } else {
        const oneWeekAgo = moment().subtract(7, "days").format("YYYY-MM-DD");
        const today = moment().format("YYYY-MM-DD");
        filtersToApply = {
          start_date: oneWeekAgo,
          end_date: today,
        };
        setActiveFilters(filtersToApply);
      }

      await getAllCentersWithFilters(filtersToApply);
      setInitialFiltersLoaded(true);
    };

    const fetchClients = () => {
      new AdminApiModule()
        .getAllClients()
        .then((res) => {
          let parsedData = [];
          if (res && res.data && res.data.length > 0) {
            parsedData = res.data;
          }
          setState((prevState) => ({ ...prevState, clientsList: parsedData }));
        })
        .catch((err) => {
          console.log(err);
        });
    };

    loadInitialData();
  }, [initialFiltersLoaded]);

  const getRecentDocumentVerify = () => {
    // Implement this function if needed
  };

  const { toast: snackBarValues } = state;
  const { error, success } = state;

  if (!canViewCenter) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
        flexDirection="column"
        p={2}
      >
        <Alert
          severity="error"
          sx={{ width: "100%", maxWidth: "500px", textAlign: "center" }}
        >
          You don't have permission to access Centers. Please contact your
          administrator.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: isMobile ? 1 : 2 }}>
      {state.error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {state.error}
        </Alert>
      )}
      {state.success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {state.success}
        </Alert>
      )}
      {state.toast.open && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={state.toast.open}
          autoHideDuration={state.toast.duration}
          onClose={closeDialog}
        >
          <Alert
            onClose={closeDialog}
            severity={state.toast.type}
            sx={{ width: "100%" }}
          >
            {state.toast.msg}
          </Alert>
        </Snackbar>
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={state.isLoading}
        onClick={stopLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Filters Component */}
      <CentersFilter
        onFilterSubmit={handleFilterSubmit}
        onClearFilters={handleClearFilters}
        primaryServices={primaryServicesList}
        secondaryServices={secondaryServicesList}
        statesList={statesList}
        initialFilters={activeFilters}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: isMobile ? "flex-start" : "center",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
          mb: 2,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          sx={{
            height: "38px",
            minWidth: isMobile ? "100%" : "auto",
          }}
          onClick={handleDownloadCSV}
        >
          Download CSV
        </Button>
        {canDefineCapacity && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#303F9F",
              height: "38px",
              minWidth: isMobile ? "100%" : "auto",
            }}
            onClick={() => setIsCapacityPopupOpen(true)}
          >
            Define Center Capacity
          </Button>
        )}
      </Box>

      <Box sx={{ mb: 2, overflow: "auto" }}>
        <Box sx={{ mb: 2, fontSize: "1.25rem", fontWeight: 500 }}>
          All Centers
        </Box>
        <Box
          sx={{
            height:
              state.centersList && state.centersList.length <= 1
                ? "auto"
                : isMobile
                ? 400
                : 600,
          }}
        >
          <DataGrid
            rows={state.centersList || []}
            columns={columns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            disableRowSelectionOnClick
            loading={state.isLoading}
            autoHeight={state.centersList && state.centersList.length <= 1}
            onColumnWidthChange={(params) => {
              // Save column width to localStorage
              const currentWidths = loadColumnWidths();
              currentWidths[params.colDef.field] = params.width;
              localStorage.setItem(
                "centersColumnWidths",
                JSON.stringify(currentWidths)
              );
            }}
            sx={{
              "& .MuiDataGrid-cell": {
                fontSize: isMobile ? "0.75rem" : "0.875rem",
                textAlign: "start",
              },
              "& .MuiDataGrid-cell[data-field='action']": {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              "& .MuiDataGrid-columnHeaders": {
                fontWeight: "bold",
                fontSize: isMobile ? "0.875rem" : "1rem",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-columnHeader[data-field='action']": {
                justifyContent: "center",
              },
            }}
          />
        </Box>
      </Box>

      <Box sx={{ mb: 2 }}>{renderTicketTable()}</Box>

      {state.isDeleteAlertPopupOpen && (
        <DeleteAlertDialogModal
          openAlert={state.isDeleteAlertPopupOpen}
          handleAlertClose={handleDeleteCloseModal}
          handleDeleteTicket={deleteCenter}
          Heading={state.deleteHeading}
        />
      )}

      <ViewActions
        isAuthorizedForPopupOpen={state.isAuthorizedForPopupOpen}
        clientsList={state.clientsList}
        toggleAuthorizedForPopup={toggleAuthorizedForPopup}
        saveAuthorizedCenters={saveAuthorizedCenters}
      />

      <ViewVerify
        isVerificationPopupOpen={state.isVerificationPopupOpen}
        toggleVerificationDetailsPopup={() =>
          toggleVerificationDetailsPopup(null, false)
        }
        selectedCenterData={state.selectedCenterData}
        adminId={state.adminId}
        selectedCenterId={state.selectedCenterId}
        panVerified={state.panVerified}
        aadhar_font={state.aadhar_font}
        aadhar_back={state.aadhar_back}
        panSwitch={state.isSwitchPan}
        aadharFront={state.isSwitchOnAdharFront}
        aadharBack={state.isSwitchOnAdharBack}
        handleSwitchToggle={handleSwitchToggle}
        handleAdharFront={handleAdharFront}
        handleAdharBack={handleAdharBack}
      />

      <SimpleCapacityPopup
        open={isCapacityPopupOpen}
        onClose={() => setIsCapacityPopupOpen(false)}
        onSubmit={handleCapacitySubmit}
        initialData={state.capacityForm}
      />

      <DefineCapacityPopup
        open={isCapacityPopupOpen1}
        onClose={() => {
          setIsCapacityPopupOpen1(false);
          setSelectedCenterForCapacity(null);
        }}
        onSubmit={handleCapacitySubmit}
        centerData={selectedCenterForCapacity}
      />
    </Box>
  );
};

export default Centers;
